import React, { Component,ReactElement,useState } from "react";
import { NavLink, Navigate } from 'react-router-dom'
import { Form } from 'react-bootstrap'
import AuthContext,{ useAuthToken, UserData,UserDataDetails } from '../../components/context/AuthContext'
import { patiApi } from '../../components/misc/PatiApi'
import { parseJwt, handleLogError } from '../../components/misc/Helpers'
import { useForm } from "react-hook-form";

import PageLayout from '../../components/layout/PageLayout'
import Input from "../../components/html/Input2";
import Button from "../../components/html/Button";
import {ThemeProps} from "../../components/styles/themeprops";
import ForgotPasswordModal from './ForgotPassword'
import unlock from'../../assests/images/unlock.svg';

type LoginFormData = { [key: string]: any; };
type LoginRequestState = { running?: boolean;isLoggedIn?:boolean,isError?:boolean, error?: string,};
type Props = {theme: ThemeProps,}

export default function Login({ theme }: Props) {
	const { register, handleSubmit, formState: { errors } } = useForm<LoginFormData>({});
  const [inputFields, setInputFields,] = useState<LoginFormData>({email:"",password:"",errors:{}});

	const [loginRequestState,setLoginRequestState,] = React.useState<LoginRequestState>({ running: false});
	const [token, userIsAuthenticated, updateToken, userLogout, userLogin, getUser] = useAuthToken();
		
	const [showModal, setShowModal] = React.useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
	const onPasswordResetClicked = ()  => {
  }
	
	const handleFormChange = (event:React.ChangeEvent<HTMLInputElement>) => {
		   inputFields[event.target.name] = event.target.value;
		   setInputFields(inputFields);
	}
		
	async function handleLogin(event:React.FormEvent<HTMLFormElement>) {
		event.preventDefault();
		setLoginRequestState({});
		const errorsN:LoginFormData = {};
		for (const el of document.getElementsByTagName('form')[0]!.querySelectorAll("[required]")) {
		  if (!(el as HTMLInputElement).reportValidity()) {
		    errorsN[(el as HTMLInputElement).name] = 'invalid';
		  }
		}
  	inputFields.errors = errorsN;
  	setInputFields(inputFields);
			
		if (Object.keys(errorsN).length>0) {
			//setLoginRequestState({ isError: true,});
			return
		}

		setLoginRequestState({
			running: true,
		});
		patiApi.authenticate(inputFields.email, inputFields.password)
			.then(response => {
				const { accessToken } = response.data
				const userId = '';
				const data: UserDataDetails = parseJwt(accessToken)
				const user: UserData = { userId, accessToken, data }

				userLogin(user)

				setLoginRequestState({
					isLoggedIn: true,
					isError: false,
				})
			}).catch(error => {
				handleLogError(error)
				setLoginRequestState({ isError: true })
			})
	}
	if (loginRequestState.isLoggedIn) {
		return (<Navigate to= { '/'} />);
	} else {
		return (
			<PageLayout title="Home" theme={theme}>
			<main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8 maincontainer">
			  <div className="container py-5 h-100">
			    <div className="row d-flex align-items-center justify-content-center h-100">
			      <div className="col-md-8 col-lg-7 col-xl-6">
			        <img src={unlock}
			          className="img-fluid" alt="Sigin"/>
			      </div>
			      <div className="col-md-7 col-lg-5 col-xl-5 offset-xl-1">
			      	<div className="float-end">{`Don't have already an account? `}
			              <a href='/signup' color='violet'>Sign Up</a>
			            </div>
			        <form className="pt-5" onSubmit={handleLogin} noValidate={true} >
			            <Input
										name="email" id="email" label="Email address" type="email"
										error={inputFields.errors.email && "Please fill in Email address"}
										disabled={loginRequestState.running}
										help="We'll never share your email with anyone else." icon="fa-solid fa-envelope"
										onChange={handleFormChange} {...{required: "required"}}
									/>
									<Input
										label="Password" name="password" id="password" type="password"
										error={inputFields.errors.password && "Please fill in password"}
										disabled={loginRequestState.running} icon="fa-solid fa-key"
										onChange={handleFormChange} {...{required: "required"}}
									/>
			
			          <div className="row mb-4">
			            <div className="col d-flex justify-content-center">
				            <div className="form-check">
				              <input className="form-check-input" type="checkbox" value="" id="rememberMe" checked />
				              <label className="form-check-label" htmlFor="form1Example3"> Remember me </label>
				            </div>
			            </div>
			            <div className="col d-flex justify-content-center">
			            <a href="#" onClick={handleShow}>Forgot password?</a>
			            </div>
			          </div>
								
								<div className="d-grid gap-2">
									{loginRequestState.isError && <div className="error-message">The username or password provided are incorrect!</div>}
			          	<Button type="submit" className="btn-lg" buttonClass="primary" disabled={loginRequestState.running}
										>Sign in</Button>
			          </div>
			
			          <div className="divider d-flex align-items-center my-4">
			            <p className="text-center fw-bold mx-3 mb-0 text-muted">OR</p>
			          </div>
			
								<div className="d-grid gap-2">
			          <a className="btn btn-primary btn-lg btn-block" style={{backgroundColor: "#3b5998"}} href="#!"
			            role="button">
			            <i className="fab fa-facebook-f me-2"></i>Continue with Facebook
			          </a>
			          <a className="btn btn-primary btn-lg btn-block" style={{backgroundColor: "#55acee"}} href="#!"
			            role="button">
			            <i className="fab fa-twitter me-2"></i>Continue with Twitter</a>
								</div>
								<ForgotPasswordModal 
                    open={showModal} onClose={handleClose} title="Fortgot your passowrd?"
                    onPasswordResetClicked={onPasswordResetClicked} 
                />
			        </form>
			      </div>
			    </div>
			  </div>
			</main>
			</PageLayout>
		);
	}
}